import { FC } from 'react'
import PreFooterSearchLinks from 'components/PreFooter/components/PreFooterSearchLinks'
import { TLocation } from 'pages/regioes-atendidas/regiao/types'
import { Address, Regions } from 'graphql/types'

export type TProps = {
  regions?: Array<Regions>
  address: Address
  locationType: TLocation
}

const PreFooter: FC<TProps> = ({ regions, address, locationType }) => {
  const hideDynamicSection = locationType === 'neighborhood'
  const hideAnotherSection = locationType === 'city'

  return (
    <PreFooterSearchLinks
      regions={{ buyerContextRegions: regions }}
      dynamicSectionOptions={{
        itemLabelPrefix: 'Imóveis em ',
        regionsLimit: 12,
      }}
      itemsPerColumn={6}
      totalColumns={1}
      address={address}
      title="Continue sua busca por imóveis"
      hideAnotherSection={hideAnotherSection}
      hideDynamicSection={hideDynamicSection}
    />
  )
}

export default PreFooter
